import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DEMOGRAPHICS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DemographicsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { YesNoOptions } from 'Common/FormHelper';
import { SiteComponent } from 'Common/SiteComponent';
class DemographicsReportFormContainer extends Component {
  ProvisionTypes = [
    { label: 'CEP/Provision 2 Only', value: 'CEP' },
    { label: 'Traditional', value: 'Traditional' },
    { label: 'Both', value: 'Both' },
  ];

  GroupBy = [
    { label: 'Site Group', value: true },
    { label: 'Site', value: false },
  ];

  render() {
    const { formValues, siteGroups, grades, loading } = this.props;

    const siteGroupsOptions = (siteGroups && siteGroups.length > 1
      ? [{ value: 'ALL', key: -1, text: 'ALL' }]
      : []
    ).concat(
      siteGroups
        ? siteGroups.map((site, i) => ({
            value: site.Id,
            key: i,
            text: `${site.Id} ${site.Description}`,
          }))
        : []
    );
    const gradeOptions = (grades && grades.length > 1
      ? [{ value: 'ALL', key: -1, text: 'ALL' }]
      : []
    ).concat(
      grades
        ? grades.map((grade, i) => ({
            value: grade.Id,
            key: i,
            text: `${grade.Id} ${grade.Description}`,
          }))
        : []
    );

    const filterSites = (site) => {
      const { formValues } = this.props;

      return formValues[Fields.SiteGroup] &&
        formValues[Fields.SiteGroup] !== 'ALL' &&
        site &&
        site.text !== 'ALL'
        ? site.sitegroupid === formValues[Fields.SiteGroup]
        : true;
    };

    return (
      <Fragment>
        <Form name={DEMOGRAPHICS_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Report Settings">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Field
                          label={'As of Student Effective Date'}
                          name={Fields.AsOfDate}
                          component={DatePickerField}
                          type="text"
                          openToDate={moment()}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'Show Grade Detail Rows?'}
                          options={YesNoOptions}
                          formName={DEMOGRAPHICS_REPORT_FORM_NAME}
                          value={formValues[Fields.ShowGradeDetailRows]}
                          fieldName={Fields.ShowGradeDetailRows}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Filter By">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <div>
                          <Field
                            name={Fields.SiteGroup}
                            component={SelectField}
                            type="text"
                            label="Site Group"
                            options={siteGroupsOptions}
                            disabled={loading}
                            onChange={() =>
                              this.props.change(
                                DEMOGRAPHICS_REPORT_FORM_NAME,
                                Fields.Site,
                                'ALL'
                              )
                            }
                          />
                        </div>
                        <SiteComponent
                          name={Fields.Site}
                          isForm={true}
                          isPrimary={false}
                          filterSites={filterSites}
                          disabled={loading}
                        />
                        <Field
                          name={Fields.Grade}
                          component={SelectField}
                          type="text"
                          label="Grade"
                          options={gradeOptions}
                          disabled={
                            loading ||
                            !formValues ||
                            !formValues[Fields.ShowGradeDetailRows]
                          }
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'Provision Type'}
                          options={this.ProvisionTypes}
                          formName={DEMOGRAPHICS_REPORT_FORM_NAME}
                          value={formValues[Fields.ProvisionType]}
                          fieldName={Fields.ProvisionType}
                          loading={loading}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className="input-group--btn-group">
                <TitledCard title="Group By">
                  <ReduxFormButtonGroup
                    options={this.GroupBy}
                    formName={DEMOGRAPHICS_REPORT_FORM_NAME}
                    value={formValues[Fields.GroupBySiteGroup]}
                    fieldName={Fields.GroupBySiteGroup}
                    disabled={loading}
                  />
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!moment(values[Fields.AsOfDate]).isValid()) {
    errors[Fields.AsOfDate] = 'Enter a valid Effective Date.';
  }
  if (!values[Fields.AsOfDate]) {
    errors[Fields.AsOfDate] = 'Effective Date must be set.';
  }
  if (!values[Fields.Site]) {
    errors[Fields.Site] = 'Site must be set.';
  }
  if (!values[Fields.CaseType]) {
    errors[Fields.CaseType] = 'Case Type must be set.';
  }
  if (!values[Fields.Grade]) {
    errors[Fields.Grade] = 'Grade must be set.';
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(DEMOGRAPHICS_REPORT_FORM_NAME)(state),
    loading: state.DemographicsReportState.demographics.loading,
    siteGroups: state.DemographicsReportState.demographics.siteGroups.Data,
    grades: state.DemographicsReportState.demographics.grades.Data,
  };
};

const DemographicsReportForm = reduxForm({
  form: DEMOGRAPHICS_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(mapStateToProps, { change })(DemographicsReportFormContainer)
  )
);

export { DemographicsReportForm };



// WEBPACK FOOTER //
// ./src/pages/demographics/components/DemographicsReportForm.js